import { render, staticRenderFns } from "./UserCourses.vue?vue&type=template&id=1660e2eb&scoped=true&"
import script from "./UserCourses.vue?vue&type=script&lang=js&"
export * from "./UserCourses.vue?vue&type=script&lang=js&"
import style0 from "./UserCourses.vue?vue&type=style&index=0&id=1660e2eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1660e2eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
